import type { ActionsOfCreators, FeatureHandler } from '../helpers';

export const inputActions = [];

export type InputActions = ActionsOfCreators<typeof inputActions>;

export type InputHandler<T extends InputActions> = FeatureHandler<
  T,
  InputActions
>;
